export default __webpack_public_path__ + "static/media/bg-light.0694bcab.png";